<label (click)="toggle()">
  <input id="{{optionId}}"  type="radio" [value]="option.value" name="{{name}}" [checked]="isChecked()" />
  @if (!toTranslate) {
    <span>{{ option.label }}</span>
  }
  @if (toTranslate) {
    <span>{{ option.label | uppercase | translate }}</span>
  }
</label>
